import React, { Component } from "react";
import { Query } from "react-apollo";

import SubscribeStreamCap from "stream/components/SubscribeStreamCap";
import ErrorBoundary from "components/Library/ErrorBoundary";
import STREAM_CAP_QUERY from "./StreamCap.graphql";

class StreamCap extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Query query={STREAM_CAP_QUERY}>
          {({ loading, data }) => {
            const { promo } = data;

            if (loading) {
              return null;
            }

            if (promo) {
              return <SubscribeStreamCap promo={promo} />;
            }

            return null;
          }}
        </Query>
      </ErrorBoundary>
    );
  }
}

export default StreamCap;
